import Vuelidate from 'vuelidate'

import Vue from 'vue'

import 'vue-awesome/icons'
import MaxLenFilter from '@/filters/maxLen'
import NoHashTagsFilter from '@/filters/noHashTags'
import CleanHashtagsFilter from '@/filters/cleanHashTags'
import BytesFilter from '@/filters/bytes'
import DateFilter from '@/filters/date'

import ability from './ability'
import { abilitiesPlugin } from '@casl/vue'
import VTooltip from 'v-tooltip'
import { stopClockInterval } from '@/store'
import { stopCheckAssetQueue } from '@/store/modules/assets'
import { hasFeature } from './featureFlags/featureFlags'


Vue.use(abilitiesPlugin, ability)
Vue.filter(MaxLenFilter.name, MaxLenFilter.fn)
Vue.filter(NoHashTagsFilter.name, NoHashTagsFilter.fn)
Vue.filter(CleanHashtagsFilter.name, CleanHashtagsFilter.fn)
Vue.filter(BytesFilter.name, BytesFilter.fn)
Vue.filter(DateFilter.name, DateFilter.fn)

Vue.use(Vuelidate as any)
Vue.use(VTooltip)

import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('icon', Icon)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// FIXME should only be here for jest
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.prototype.$hasFeature = hasFeature

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    // @ts-ignore
    el.event = event => {
      if (!(el === event.target || el.contains(event.target))) {
        if (vnode && vnode.context) {
          vnode.context[binding.expression](event)
        }
      }
    }
    // @ts-ignore
    document.body.addEventListener('click', el.event)
  },
  unbind: function (el) {
    // @ts-ignore
    document.body.removeEventListener('click', el.event)
  }
})

try {
  afterEach(() => {
    // FIXME: this is necessary to close tests properly, but should be dealt with properly
    stopClockInterval()
    stopCheckAssetQueue()
  })
} catch (_error) {}
